import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-logger-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './logger-page.component.html',
  styleUrl: './logger-page.component.css'
})
export class LoggerPageComponent {

}
